<template>
    <rkm-list-group>
        <List
            :limit="null"
            :data="data"
        />
    </rkm-list-group>
</template>

<script>
//Components
import List from '../List'

export default {
    components: { List },
    props: {
        data: { type: Object, required: true },
    },
}
</script>